import { Component } from 'react'
import { NumericFormat } from 'react-number-format'
import { getCurrency } from 'utils/authService'

class ValueCellRenderer extends Component {
  render() {
    const { data } = this.props
    if (!data) return null
    const { value } = data
    return (
      <NumericFormat
        displayType="text"
        thousandSeparator
        value={value}
        prefix={getCurrency().symbol}
      />
    )
  }
}

export default ValueCellRenderer
